import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Download Scanner Apps</Typography>
      <p>If you are using one of our Smartix Managed Templates then you will need
        our Smartix Scan App. 
      </p>

      <p>We have links here to Apple Appstore and Google Playstore for you to download the apps.
        Alternatively, just search for Smartix on your device.
      </p>
    </div>
  )
}

export default HelpText